import { Compensation } from "@/services/DTOs/Compensation";

export interface ICandidateStatus {
  id?: string;
  interested?: string | Date;
  compensation?: Compensation;
  status?: string;
}

export class CandidateStatus {
  public id?: string;
  public interested?: string | Date;
  public compensation?: Compensation;
  public status?: string;

  constructor(data: ICandidateStatus) {
    this.id = data.id;
    this.interested = data.interested;
    this.compensation = data.compensation ? new Compensation(data.compensation) : undefined;
    this.status = data.status;
  }
}
